import React from "react";
import { computeAvailableCombinations } from './details/combinations.js';
import "./CourtItemCourts.css";

const CourtItemCourts = ({ courts }) => {
  if (!courts || courts.length === 0) return null;

console.log("court info is:", courts)

  const availableOptions = computeAvailableCombinations(courts);
  const courtMap = {};
  courts.forEach((court) => {
    courtMap[court.name] = court;
  });

  // Function to categorize a court based on its dimensions
  const getCourtCategory = (width, length) => {
    if (typeof width !== 'number' || typeof length !== 'number' || isNaN(width) || isNaN(length)) {
      return "Unknown";
    }
  
    if (width <= 12.5 && length <= 20) {
      return "Junior";
    } else if (width < 16 && length < 31) {
      return "Small";
    } else if (width < 18 && length < 38) {
      return "Medium";
    } else if (width >= 18 && length >= 38) {
      return "International";
    } else {
      return "Unknown";
    }
  };

  // Function to generate a summary for a combination of courts
  const getCombinationSummary = (combo) => {
    const categoryCounts = {
      Junior: 0,
      Small: 0,
      Medium: 0,
      International: 0,
      Unknown: 0, // Add a category for unknown dimensions
    };

    combo.forEach((courtName) => {
      const court = courtMap[courtName];
  
      if (!court || typeof court.width !== 'number' || typeof court.length !== 'number') {
        categoryCounts.Unknown++;
      } else {
        const category = getCourtCategory(court.width, court.length);
        categoryCounts[category]++;
      }
    });

    // Build the summary as an array of strings with bullet points
    const summaryParts = [];
    if (categoryCounts.Junior > 0) {
      const courtText = categoryCounts.Junior === 1 ? "Court" : "Courts";
      summaryParts.push(`• ${categoryCounts.Junior} Junior ${courtText}`);
    }
    if (categoryCounts.Small > 0) {
      const courtText = categoryCounts.Small === 1 ? "Court" : "Courts";
      summaryParts.push(`• ${categoryCounts.Small} Small ${courtText}`);
    }
    if (categoryCounts.Medium > 0) {
      const courtText = categoryCounts.Medium === 1 ? "Court" : "Courts";
      summaryParts.push(`• ${categoryCounts.Medium} Medium ${courtText}`);
    }
    if (categoryCounts.International > 0) {
      const courtText = categoryCounts.International === 1 ? "Court" : "Courts";
      summaryParts.push(`• ${categoryCounts.International} International ${courtText}`);
    }
    if (categoryCounts.Unknown > 0) {
      const courtText = categoryCounts.Unknown === 1 ? "Court" : "Courts";
      summaryParts.push(`• ${categoryCounts.Unknown} ${courtText}`);
    }

    return summaryParts;
  };

  return (
    <div className="court-item-combinations-container">
    {availableOptions.map((combo, index) => (
      <div key={index} className="combination-item-column">
        {/* Add the summary at the start of each row */}
        <div className="combination-summary">
          {getCombinationSummary(combo).map((summary, i) => (
            <div key={i} className="court-item-summary-line">{summary}</div>
          ))}
        </div>
      </div>
    ))}
  </div>
  );
};

export default CourtItemCourts;